import script from "./TheWelcome.vue?vue&type=script&setup=true&lang=js"
export * from "./TheWelcome.vue?vue&type=script&setup=true&lang=js"

import "./TheWelcome.vue?vue&type=style&index=0&id=4f1eb5d2&lang=css"

const __exports__ = script;

export default __exports__